import TeamIndex, { loader as teamIndexLoader } from '.';
import TeamLayout from './layouts/TeamLayout';
import TeamCalendar from './pages/TeamCalendar';
import TeamFonts from './pages/TeamFonts';
import TeamGraphics from './pages/TeamGraphics';
import TeamInbox from './pages/TeamInbox';
import TeamLibrary from './pages/TeamLibrary';
import TeamMusic from './pages/TeamMusic';
import TeamPayslips from './pages/TeamPayslips';
import TeamProjects, { loader as teamProjectsLoader } from './pages/TeamProjects';
import TeamSettings from './pages/TeamSettings';
import TeamStock from './pages/TeamStock';
import TeamSupport from './pages/TeamSupport';
import TeamTimesheet from './pages/TeamTimesheet';
import TeamClients from './pages/TeamClients';

import TeamProjectDetails, {
  action as teamProjectDetailsAction,
  loader as teamProjectDetailsLoader,
} from './pages/TeamProjectDetails';

export const teamRoutes = {
  path: 'team',
  element: <TeamLayout />,
  children: [
    { index: true, element: <TeamIndex />, loader: teamIndexLoader },
    {
      path: 'projects/:projectId',
      element: <TeamProjectDetails />,
      loader: teamProjectDetailsLoader,
      action: teamProjectDetailsAction,
    },
    { path: 'inbox', element: <TeamInbox /> },
    { path: 'projects', element: <TeamProjects />, loader: teamProjectsLoader },
    { path: 'clients', element: <TeamClients /> },
    { path: 'library', element: <TeamLibrary /> },
    { path: 'stock', element: <TeamStock /> },
    { path: 'graphics', element: <TeamGraphics /> },
    { path: 'fonts', element: <TeamFonts /> },
    { path: 'music', element: <TeamMusic /> },
    { path: 'calendar', element: <TeamCalendar /> },
    { path: 'timesheet', element: <TeamTimesheet /> },
    { path: 'payslips', element: <TeamPayslips /> },
    { path: 'support', element: <TeamSupport /> },
    { path: 'settings', element: <TeamSettings /> },
  ],
};
